module.exports = __webpack_public_path__ + "media/bootstrap-icons/file-diff-fill-3218c3fe.svg";